(function() {
    const GestioneUtenteService = function(
        $http,
        CONSTANTS
    ) {
        this.datiMito = null;
        this.praticaPic = null;
        this.readonly = false;
        this.creatorePratica = null;
        this.configurazioniBanca = null;
        this.mitoForm = null;

        this.reset = () => {
            this.datiMito = null;
            this.praticaPic = null;
            this.readonly = false;
            this.creatorePratica = null;
            this.configurazioniBanca = null;
            this.mitoForm = null;
        };

        this.getMenu = () => {
            return CONSTANTS.MENU;
        };

        this.getDatiCliente = (ndg) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.ANAGRAFICA.RECUPERA + '/' + ndg,
                cache: true
            });
        };

        this.recuperaConfigurazioni = (tipoPratica) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.DOMINI.CONFIGURAZIONI + tipoPratica
            });
        };

        this.getDatiMito = (codiceMito) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO + codiceMito
            });
        };

        this.getRapportiPraticaMito = (codiceMito) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.LISTA_RAPPORTI + codiceMito
            });
        };

        this.getWizard = (codiceMito) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.WIZARD + codiceMito
            });
        };

        this.getPraticaByIdDaPic = (idPratica) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO_DA_ID + idPratica
            });
        };

        this.getRapportiPraticaByIdDaPic = (idPratica) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.RAPPORTI_DA_ID + idPratica
            });
        };

        this.getDefaultDto = (ndg, codiceProdotto) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DEFAULT_DTO + ndg + "/" + codiceProdotto
            });
        };
        
        this.getCreatorePraticaPic = (idPratica) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.CREATORE + idPratica
            });
        };

        this.creaPraticaVariazione = (codiceMito) => {
            return $http({
                method: 'POST',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.VARIA,
                data: codiceMito
            });
        };

        this.salvaPraticaPic = (pratica) => {
            return $http({
                method: 'POST',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.SALVA,
                data: pratica
            });
        };

        this.avanzaPraticaPic = (pratica) => {
            return $http({
                method: 'POST',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.AVANZA,
                data: pratica
            });
        };

        this.consolidaPraticaPic = (pratica) => {
            return $http({
                method: 'POST',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.CONSOLIDA,
                data: pratica
            });
        };

        this.presentaPraticaPic = (backofficeActionDto) => {
            return $http({
                method: 'POST',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.PRESENTA,
                data: backofficeActionDto
            });
        };

        this.annullaPraticaPic = (backofficeActionDto) => {
            return $http({
                method: 'POST',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.ANNULLA,
                data: backofficeActionDto
            });
        };

        this.accettaPraticaPic = (backofficeActionDto) => {
            return $http({
                method: 'POST',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.ACCETTA,
                data: backofficeActionDto
            });
        };

        this.revisionaPraticaPic = (backofficeActionDto) => {
            return $http({
                method: 'POST',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.REVISIONA,
                data: backofficeActionDto
            });
        };
        
        this.prendiInCaricoPratica = (backofficeActionDto) => {
            return $http({
                method: 'POST',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.PRENDIINCARICO,
                data: backofficeActionDto
            });
        };
        
        this.rilasciaPratica = (backofficeActionDto) => {
            return $http({
                method: 'POST',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.RILASCIA,
                data: backofficeActionDto
            });
        };

        this.rifiutaPratica = (backofficeActionDto) => {
            return $http({
                method: 'POST',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.RIFIUTA,
                data: backofficeActionDto
            });
        };
        
        this.spostaInStatoInCorso = (pratica) => {
            return $http({
                method: 'POST',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.INCORSO,
                data: pratica
            });
        };

        this.getDatiBusiness = (codiceMito) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.MITO.DETTAGLIO + codiceMito
            });
        };

        this.getRapportiVisibili = (codiceMito) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.MITO.LISTA_RAPPORTI + codiceMito
            });
        };

        this.recuperaDnsMito = (idOrganizzazione) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.MITO8.DNS + idOrganizzazione
            });
        };

        this.estinguiUtenzaMito = (codiceMito) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.MITO.ESTINGUI + codiceMito
            });
        };

        this.ribaltaRapporti = (codiceMito) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.MITO.RIBALTA + codiceMito
            });
        };

        this.creaAttivazione = (codiceMito) => {
            return $http({
                method: 'POST',
                url: CONSTANTS.REST_MITO8_ROOT + CONSTANTS.REST.MITO8.ATTIVAZIONE,
                data: codiceMito
            });
        };

        this.checkCampoDisabilitato = (nomeCampo) => {
            return this.readonly || (!!this.configurazioniBanca && !!this.configurazioniBanca[nomeCampo] && this.configurazioniBanca[nomeCampo].disabilitato);
        };

        this.checkCampoObbligatorio = (nomeCampo) => {
            return !this.readonly && !!this.configurazioniBanca && !!this.configurazioniBanca[nomeCampo] && this.configurazioniBanca[nomeCampo].obbligatorio;
        };

        this.checkCampoVisibile = (nomeCampo) => {
            return (this.configurazioniBanca[nomeCampo] == undefined) || this.configurazioniBanca[nomeCampo].visibile;
        };
        
        this.checkCampoValido = (nomeCampo) => {
            return this.mitoForm[nomeCampo].$valid || !this.cache.get('action');
        };

        this.getProdottoDisponibile = (codiceProdotto) => {
            return $http({
                method: 'GET',
                url: '/MSF-OFFERMANAGER-MF/api/PropostaGenerica/RecuperaProdotto',
                params: { codiceProdotto: codiceProdotto }
            });
        };

        this.setUtenzaMito = (utenzaMito) => {
            this.datiMito = utenzaMito;
        }
    };

    GestioneUtenteService.$inject = [
        '$http',
        'Mitom_CONSTANTS'
    ];

    angular
        .module('cbl.mitomanager.wa')
        .service('MitomGestioneUtenteService', GestioneUtenteService);
})();